import CourseUserListContainer from '@src/components/user/list/CourseUserListContainer';
import React from 'react';
import { withRouter, WithRouterProps } from 'react-router';

const CourseUserListPage = (props: WithRouterProps) => <CourseUserListContainer courseId={props.params.courseId} />;

export default withRouter(CourseUserListPage);
